import { createElement } from 'react';

// Renders CMS-authored HTML (the "orange text easily editable in HTML" fields).
// Editors write real HTML in the Strapi richtext field — e.g.
// `Jak na datově řízený <em>e-mailing</em>` or `<strong>24,38 %</strong>` — and it
// is rendered verbatim. Content is authored by trusted CMS editors, same trust
// level as the rest of the site's content blocks.
const WebinarHtml = ({ html, as = 'div', className = '' }) => {
  if (!html) return null;
  return createElement(as, { className, dangerouslySetInnerHTML: { __html: html } });
};

export default WebinarHtml;
